import { isObject, isEmpty } from 'lodash';
import omitUndefinedProps from 'sharedParts/utils/omitUndefinedProps';

const clearObjectDeep = obj =>
  JSON.parse(
    JSON.stringify(obj, (key, value) => {
      if (isObject(value) && isEmpty(omitUndefinedProps(value))) {
        return undefined;
      }
      return value;
    }),
  );

export default clearObjectDeep;
